import { render, staticRenderFns } from "./SharepointSites.vue?vue&type=template&id=623e15b5&"
import script from "./SharepointSites.vue?vue&type=script&lang=ts&"
export * from "./SharepointSites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports